import { MIGRATION_SCOPE, SOLUTION_PAGE_HEROES } from '../../../../content/enterpriseMessaging';
import HeroPullQuote from '../../shared/HeroPullQuote';
import PartnerBadges from './PartnerBadges';

const PILL_CLASSES = ['badge-migration', 'badge-semantic', 'badge-brand', 'badge-enterprise'];

function TopEdgePill({ text, badgeClass = 'badge-migration' }) {
  return (
    <span
      className={`absolute -top-3 left-1/2 z-10 max-w-[calc(100%-2rem)] -translate-x-1/2 ${badgeClass} whitespace-normal break-words shadow-sm`}
    >
      {text}
    </span>
  );
}

export default function Chatbot() {
  const hero = SOLUTION_PAGE_HEROES.dataEngineering;

  return (
    <div className="container-x section">
      <div className="relative mx-auto max-w-3xl mt-4 text-center">
        <TopEdgePill text={MIGRATION_SCOPE.eyebrow} badgeClass="badge-enterprise" />
        <div className="relative px-6 py-10 sm:px-10 sm:py-12">
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-ink-900">
            {hero.title}
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-ink-600 leading-relaxed">{hero.body}</p>

          <PartnerBadges compact />

          <HeroPullQuote eyebrow="Migration programs">{hero.quote}</HeroPullQuote>

          <div className="mt-6 flex flex-wrap justify-center gap-2">
            {MIGRATION_SCOPE.platforms.map((platform, index) => (
              <span key={platform} className={PILL_CLASSES[index % PILL_CLASSES.length]}>
                {platform}
              </span>
            ))}
          </div>

          <div className="mt-8 flex w-full min-w-0 flex-col sm:flex-row items-center justify-center gap-3">
            <a href={hero.primaryCta.href} className="btn-primary btn-lg">
              {hero.primaryCta.label}
            </a>
            <a href={hero.secondaryCta.href} className="btn-secondary btn-lg">
              {hero.secondaryCta.label}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
